import base64 from 'base-64'
import utf8 from 'utf8'
import { default as parseDate } from 'date-fns__legacy__/parse'
import isValid from 'date-fns__legacy__/is_valid'
import differenceInHours from 'date-fns__legacy__/difference_in_hours'

const encode = value => base64.encode(utf8.encode(value))
const decode = value => utf8.decode(base64.decode(value))

const key = encode('mpFirstAccess-v2')

const getLocalStorageData = () => {
  const acessList = localStorage.getItem(key)

  if (acessList) {
    return JSON.parse(decode(acessList))
  } else {
    return {}
  }
}

/**
 * @param {number} enumerator
 * @returns {Date}
 */
export const getFirstAccessDate = (enumerator) => {
  const acessList = getLocalStorageData()
  const dateISO = acessList[enumerator] || ''

  return parseDate(dateISO)
}

export const hasFirstAccess = (enumerator) => {
  const accessDate = getFirstAccessDate(enumerator)

  return isValid(accessDate)
}

export const isWithinFirstAccessDate = (enumerator, hours) => {
  const accessDate = getFirstAccessDate(enumerator)

  if (!isValid(accessDate)) { return null }

  const today = new Date()
  const hourDiff = differenceInHours(today, accessDate)

  return hourDiff < hours
}

export const setFirstAcess = (enumerator) => {
  const acessList = getLocalStorageData()

  const today = new Date()
  const todayISO = today.toISOString()

  acessList[enumerator] = todayISO
  localStorage.setItem(key, encode(JSON.stringify(acessList)))

  return today
}

export default {
  getFirstAccessDate,
  isWithinFirstAccessDate,
  setFirstAcess,
}